import axios from "axios";
import { store } from "../store";

const baseURL = process.env.REACT_APP_EMPLOYEE_PORTAL_API;

const Axios = axios.create({
    baseURL,
});

const getBasicHeaders = () => {
  const authCompanySelectedState = store.getState().auth.companyselected;
  return {
    'user-token': authCompanySelectedState?.Token,
    'moduleid': process.env.REACT_APP_MODULE_ID,
    'x-api-key': process.env.REACT_APP_EMPLOYEE_PORTAL_API_KEY,
    'env': process.env.REACT_APP_ENV,
    'Content-Type': 'application/json',
  };
}

export const  getUserPreferences = async () => {
  const headers = await getBasicHeaders();
  const responde = await Axios.get('user-preferences', {headers})
    .catch(error => {
      console.error('Error fetching user preferences:', error);
      return null;
    });
  console.log('--- responde', responde)
  if (responde?.data?.success && responde?.data?.data) {
    return responde?.data;
  }
  return null
}


export const  saveUserPreferences = async (preferences: any) => {
  const headers = await getBasicHeaders();
  const responde = await Axios.post('user-preferences', preferences, {headers})
    .catch(error => {
      console.error('Error fetching user preferences:', error);
      return null;
    });
  console.log('--- responde', responde)
  if (responde?.data?.success && responde?.data?.data) {
    return responde?.data;
  }
  return {}
}
